import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export function useIsStaff() {
  const { userId } = useCurrentUser();

  const { data: isStaff = false, isLoading } = useQuery({
    queryKey: ["isStaff", userId],
    queryFn: async () => {
      if (!userId) return false;
      const { data: isAdmin } = await supabase.rpc("has_role", {
        _user_id: userId,
        _role: "admin",
      });
      if (isAdmin) return true;
      const { data: isOwner } = await supabase.rpc("has_role", {
        _user_id: userId,
        _role: "owner",
      });
      if (isOwner) return true;
      // Only Helper+ (promoted helpers) count as staff
      const { data: isPromoted } = await supabase.rpc("is_helper_plus", {
        _user_id: userId,
      });
      return !!isPromoted;
    },
    enabled: !!userId,
    staleTime: Infinity,
  });

  return { isStaff, isLoading };
}
